export default {
	saveLang(lang) {
		localStorage.setItem('i18nextLng',lang)
	},
	readLang(lang) {
		return localStorage.getItem('i18nextLng')
	}
}